import { type AxiosResponse } from 'axios';
import { camelizeKeys } from 'humps';

// All B2B endpoints route through Apigee, the same gateway the login app uses.
// Apigee handles per-path auth (JWT for protected routes, pre-auth for
// login/signin/etc.) and includes localhost in its CORS allowlist, so the
// same URL works in `expo start --web`, native, and production builds.
const baseURL =
  process.env.EXPO_PUBLIC_API_BASE_URL ??
  process.env.EXPO_PUBLIC_B2B_BASE_URL ??
  'https://staging-api.vida.com';

// Apigee runs in "dual-mint" mode by default (EXPO_PUBLIC_SKIP_LEGACY_SESSION
// unset/false): it returns BOTH a JWT and a Django `sessionid` cookie, and
// auth-protected endpoints expect both. `withCredentials: true` tells the
// browser to attach the cookie on cross-origin calls.
export const axiosConfig = {
  baseURL,
  timeout: 30_000,
  withCredentials: true,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
};

// Server speaks snake_case but the codebase is camelCase end-to-end. Camelize
// every JSON response body once at the boundary so callers can author plain
// camelCase types. Request bodies stay camelCase in app code; call sites
// decamelize with humps before POST/PUT (see eligibility.check, createUser, login).
export const camelizeResponse = <T extends AxiosResponse>(response: T): T => {
  if (response.data && typeof response.data === 'object') {
    response.data = camelizeKeys(response.data) as T['data'];
  }
  return response;
};
